import { Resolver, Mutation, Arg, Ctx, Directive } from 'type-graphql'

import { DataSummary } from './data-summary.js'
import { finalizeDataCollection, finalizeLatestDataCollection } from '../../controllers/finalize-data-collection.js'

@Resolver(DataSummary)
export class DataSummaryMutation {
  @Directive('@transaction')
  @Mutation(returns => Boolean, {
    description: 'Deprecated. Use finalizeLatestDataCollection',
    deprecationReason: 'This resolver has been replaced by finalizeLatestDataCollection'
  })
  async generateLatestDataSummaries(
    @Arg('dataSetId') dataSetId: string,
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    return await finalizeLatestDataCollection(dataSetId, context)
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, {
    description:
      'Finalizes and generates the latest data summaries for the specified dataset. This operation aggregates collected data into summary records for reporting and analysis.'
  })
  async finalizeLatestDataCollection(
    @Arg('dataSetId') dataSetId: string,
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    return await finalizeLatestDataCollection(dataSetId, context)
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, {
    description: 'Deprecated. Use finalizeDataCollection',
    deprecationReason: 'This resolver has been replaced by finalizeDataCollection'
  })
  async generateDataSummaries(
    @Arg('dataSetId') dataSetId: string,
    @Arg('date') date: string,
    @Arg('period') period: string,
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    return await finalizeDataCollection(dataSetId, date, period, context)
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, {
    description:
      'Finalizes data collection for a specific period and generates summary records. This operation processes all collected data within the specified time range.'
  })
  async finalizeDataCollection(
    @Arg('dataSetId') dataSetId: string,
    @Arg('date') date: string,
    @Arg('period') period: string,
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    return await finalizeDataCollection(dataSetId, date, period, context)
  }
}
